import { BACKEND_BASE_URL, IResponseError } from "@/services";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import { IOrderPendingService } from "@/services/backend/order_pending/order_pending.types";
import { IRequestHistorialsService } from "@/entities";

export class OrderPendingService implements IOrderPendingService {
  async getOrdersPending(
    servicePointId?: string
  ): Promise<IRequestHistorialsService[] | undefined> {
    const { response, error } = await handleResponse<IRequestHistorialsService[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/order/${servicePointId}`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
